export enum ExternalServiceName {
  ADP = 'ADP',
  BAMBOOHR = 'BAMBOOHR',
  CARTA_WORKDAY = 'CARTA_WORKDAY',
  CHARTHOP = 'CHARTHOP',
  DEGREED = 'DEGREED',
  DOCEBO = 'DOCEBO',
  DOCEBO_IFRAME = 'DOCEBO_IFRAME',
  GUSTO = 'GUSTO',
  INTELLUM = 'INTELLUM',
  LATTICE = 'LATTICE',
  MERGE = 'MERGE',
  OPENAI = 'OPENAI',
  PRISM = 'PRISM',
  RIPPLING = 'RIPPLING',
  RUSTICI = 'RUSTICI',
  SALESFORCE = 'SALESFORCE',
  SLACK = 'SLACK',
  SMARTCAT = 'SMARTCAT',
  TEST_MESSAGE_BOT_SERVICE = 'TEST_MESSAGE_BOT_SERVICE',
  TEST_HRIS_SERVICE = 'TEST_HRIS_SERVICE',
  UKG = 'UKG',
  VANTA = 'VANTA',
  WORKDAY_BASIC_AUTH = 'WORKDAY_BASIC_AUTH',
  WORKDAY_OAUTH = 'WORKDAY_OAUTH',
  ZOOM = 'ZOOM',
  ZOOM_CHAT = 'ZOOM_CHAT',
  ZOOM_WORKDAY = 'ZOOM_WORKDAY',
}

export enum ExternalServiceType {
  HRIS = 'HRIS',
  LMS = 'LMS',
  LRS = 'LRS',
  MESSAGE_BOT = 'MESSAGE_BOT',
  SCP = 'SCP',
  TRANSLATION = 'TRANSLATION',
  VIDEO = 'VIDEO',
  OTHER = 'OTHER',
}

export enum PartnershipCompanyCredentialName {
  API_URL = 'API_URL',
  CERT_BASE64 = 'CERT_BASE64',
  CLIENT_ID = 'CLIENT_ID',
  CLIENT_SECRET = 'CLIENT_SECRET',
  JWT_AUDIENCE = 'JWT_AUDIENCE',
  JWT_ISSUER = 'JWT_ISSUER',
  JWT_SECRET = 'JWT_SECRET',
  KEY_BASE64 = 'KEY_BASE64',
  OAUTH_URL = 'OAUTH_URL',
  PASSWORD = 'PASSWORD',
  PULL_URL = 'PULL_URL',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  SALT = 'SALT',
  USERNAME = 'USERNAME',
}
